<template>
    <v-card class="app-panel" elevation="8">
        <div class="panel-head">
            <v-icon small :color="iconColor" class="mr-2">{{ icon }}</v-icon>
            <div class="panel-title">{{ title }}</div>
            <v-btn v-if="collapsible" icon x-small @click="expanded = !expanded">
                <v-icon small>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
            </v-btn>
            <v-btn icon x-small class="ml-1" :disabled="closeDisabled" @click="$emit('close')">
                <v-icon small>mdi-close</v-icon>
            </v-btn>
        </div>

        <v-progress-linear
            v-if   = "progress !== null"
            :value = "progress"
            :color = "progressColor"
            height = "4"
        />

        <div v-if="expanded" class="panel-body">
            <slot></slot>
        </div>
    </v-card>
</template>

<script>
/**
 * A small card with a title bar (icon, title, collapse and close) for what the app tells the user next to
 * their work: the uploads, the hint to a new version. [AppPanels] in App.vue stacks them at the bottom
 * right. The content goes into the default slot.
 */
export default {
    name: "CAppPanel",

    props: {
        icon         : { type: String, default: "mdi-information" },
        iconColor    : { type: String, default: "primary" },
        title        : { type: String, required: true },
        /** Shows a bar with this value (0..100); none if null. */
        progress     : { type: Number, default: null },
        progressColor: { type: String, default: "primary" },
        collapsible  : { type: Boolean, default: false },
        closeDisabled: { type: Boolean, default: false },
    },

    data: () => ({
        expanded: true
    })
}
</script>

<style scoped>
.app-panel {
    width: 360px;
    max-width: calc(100vw - 32px);
}

.panel-head {
    display: flex;
    align-items: center;
    padding: 8px 10px 6px 12px;
}

.panel-title {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
}

.panel-body {
    max-height: 260px;
    overflow-y: auto;
    padding: 4px 12px 10px;
}
</style>
